export const VARIANT_TAG_CRUD_FORM_CANCEL = () => ({
    variantTagCRUD: {
        status: "",
        meta: {
            title: '',
            button: '',
            type: ''
        },
        payload: null
    }
});
export const VARIANT_TAG_CRUD_FORM_BATCH_EDIT = (payload) => ({
    variantTagCRUD: {
        status: "DONE",
        meta: {
            title: 'batch edit',
            button: '',
            type: 'edit'
        },
        payload: payload
    }
});
export const VARIANT_TAG_CRUD_FORM_DONE = (payload) => ({
    variantTagCRUD: {
        status: "DONE",
        meta: {
            title: 'edit',
            button: 'save',
            type: 'edit'
        },
        payload: payload
    }
});
export const VARIANT_TAG_CRUD_FORM_DELETE = (payload) => ({
    variantTagCRUD: {
        status: "DONE",
        meta: {
            title: 'delete',
            button: 'delete',
            type: 'delete'
        },
        payload: payload
    }
});
export const VARIANT_TAGS_DISPLAY_BAR = (payload) => ({
    variantTags: payload
});

export const VARIANT_DISCOUNTS_DISPLAY_BAR = (payload) => ({
    variantDiscounts: payload
});

export const VARIANT_DISCOUNTS_CRUD_FORM_CANCEL = () => ({
    variantDiscountsCRUD: {
        status: "",
        meta: {
            title: '',
            button: '',
            type: ''
        },
        payload: null
    }
});
export const VARIANT_DISCOUNTS_CRUD_FORM_BATCH_EDIT = (payload) => ({
    variantDiscountsCRUD: {
        status: "DONE",
        meta: {
            title: 'batch edit',
            button: '',
            type: 'edit'
        },
        payload: payload
    }
});
export const VARIANT_DISCOUNTS_CRUD_FORM_DONE = (payload) => ({
    variantDiscountsCRUD: {
        status: "DONE",
        meta: {
            title: 'edit',
            button: 'save',
            type: 'edit'
        },
        payload: payload
    }
});
export const VARIANT_DISCOUNTS_CRUD_FORM_DELETE = (payload) => ({
    variantDiscountsCRUD: {
        status: "DONE",
        meta: {
            title: 'delete',
            button: 'delete',
            type: 'delete'
        },
        payload: payload
    }
});